<template>
  <div>
    <el-row :gutter="20">
      <!-- 左侧：状态列表 -->
      <el-col :span="3">
        <el-card class="list-selector">
          <ul class="list-selector-list">
            <li @click="handleStateSelect('')"
              :class="{ 'selected': upShopHouseManageInfo.conditions.state === '' }">
              全部
            </li>
            <li v-for="(item, index) in upShopHouseManageInfo.states" :key="index"
              @click="handleStateSelect(item.statusCd)"
              :class="{ 'selected': upShopHouseManageInfo.conditions.state === item.statusCd }">
              {{ item.name }}
            </li>
          </ul>
        </el-card>
      </el-col>

      <!-- 右侧：查询条件和表格 -->
      <el-col :span="21">
        <!-- 查询条件 -->
        <el-card class="ibox">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('upShopHouseManage.queryCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="upShopHouseManageInfo.conditions" class="flex justify-start">
              <el-form-item>
                <el-form-item>
                  <el-input v-model="upShopHouseManageInfo.conditions.personName"
                    :placeholder="$t('upShopHouseManage.inputApplicant')" clearable />
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-form-item>
                  <el-input v-model="upShopHouseManageInfo.conditions.orderId"
                    :placeholder="$t('upShopHouseManage.inputOrderNo')" clearable />
                </el-form-item>
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="upShopHouseManageInfo.conditions.queryStartTime"
                  type="date"
                  placeholder="开始时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-date-picker
                  v-model="upShopHouseManageInfo.conditions.queryEndTime"
                  type="date"
                  placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  clearable
                  style="width: 100%"
                />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" @click="_queryShopHouseMethod">
                  <i class="el-icon-search"></i> {{ $t('common.query') }}
                </el-button>
                <el-button type="primary" size="small" @click="_resetShopHouseMethod">
                  <i class="el-icon-refresh"></i> {{ $t('common.reset') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <!-- 采购单表格 -->
        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('upShopHouseManage.purchaseOrder') }}</div>
            <div class="ibox-tools">
              <el-button type="primary" size="small" @click="_openAddShopHouseModal">
                <i class="el-icon-plus"></i> {{ $t('upShopHouseManage.applyPurchase') }}
              </el-button>
            </div>
          </div>
          <div class="">
            <el-table :data="upShopHouseManageInfo.inoutOrders" border style="width: 100%">
              <el-table-column prop="orderId" :label="$t('upShopHouseManage.orderNo')" align="center" />
              <el-table-column prop="prodName" :label="$t('upShopHouseManage.goods')" align="center" />
              <el-table-column prop="stateName" :label="$t('upShopHouseManage.status')" align="center" />
              <el-table-column prop="personName" :label="$t('upShopHouseManage.applicant')" align="center" />
              <el-table-column prop="createTime" :label="$t('upShopHouseManage.applyTime')" align="center" />
              <el-table-column prop="remark" :label="$t('upShopHouseManage.remark')" align="center" />
              <el-table-column :label="$t('common.operation')" align="center" width="200">
                <template #default="scope">
                  <el-button v-if="scope.row.state == '1001' && hasPrivilege('502025011409820001')" type="text" size="small"
                    @click="_openAuditModal(scope.row)">
                    {{ $t('common.audit') }}
                  </el-button>
                  <el-button type="text" size="small" @click="_toDetail(scope.row)">
                    {{ $t('common.detail') }}
                  </el-button>
                  <el-button type="text" size="small" @click="_deleteUpShopHouse(scope.row)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handleCurrentChange" :current-page="upShopHouseManageInfo.conditions.page"
              :page-size="upShopHouseManageInfo.conditions.row" layout="total, prev, pager, next"
              :total="upShopHouseManageInfo.total" />
          </div>
        </el-card>
      </el-col>
    </el-row>

    <delete-inout-order ref="deleteInoutOrder" @refresh="_listInoutOrder" />
    <up-shop-house-audit ref="upShopHouseAudit" @refresh="_listInoutOrder" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'
import { queryInoutOrder } from '@/api/goods/inoutOrderApi'
import DeleteInoutOrder from '@/components/goods/deleteInoutOrder'
import UpShopHouseAudit from '@/components/goods/upShopHouseAudit/upShopHouseAudit'

export default {
  name: 'UpShopHouseManage',
  components: {
    DeleteInoutOrder,
    UpShopHouseAudit
  },
  data() {
    return {
      upShopHouseManageInfo: {
        inoutOrders: [],
        total: 0,
        records: 1,
        states: [],
        conditions: {
          personName: '',
          orderId: '',
          orderType: '10000',
          state: '',
          shopId: '',
          queryStartTime: '',
          queryEndTime: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.upShopHouseManageInfo.conditions.shopId = getShopId()
    this._listInoutOrder()
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('inout_order', 'state')
        this.upShopHouseManageInfo.states = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    async _listInoutOrder(page = 1, rows = 10) {
      this.upShopHouseManageInfo.conditions.page = page
      this.upShopHouseManageInfo.conditions.row = rows
      try {
        const res = await queryInoutOrder(this.upShopHouseManageInfo.conditions)
        this.upShopHouseManageInfo.total = res.total
        this.upShopHouseManageInfo.records = res.records
        this.upShopHouseManageInfo.inoutOrders = res.data
        console.log(this.upShopHouseManageInfo.records)
      } catch (error) {
        console.error('请求失败:', error)
      }
    },
    _openAddShopHouseModal() {
      this.$router.push('/pages/goods/upShopHouseInManage')
    },
    _queryShopHouseMethod() {
      this._listInoutOrder()
    },
    _resetShopHouseMethod() {
      this.upShopHouseManageInfo.conditions.personName = ''
      this.upShopHouseManageInfo.conditions.orderId = ''
      this.upShopHouseManageInfo.conditions.queryStartTime = ''
      this.upShopHouseManageInfo.conditions.queryEndTime = ''
      this._listInoutOrder()
    },
    handleStateSelect(state) {
      this.upShopHouseManageInfo.conditions.state = state
      this.upShopHouseManageInfo.conditions.page = 1
      this._listInoutOrder(1, this.upShopHouseManageInfo.conditions.row)
    },
    _deleteUpShopHouse(row) {
      this.$refs.deleteInoutOrder.open(row)
    },
    _openAuditModal(row) {
      this.$refs.upShopHouseAudit.open(row)
    },
    _toDetail(row) {
      this.$router.push(`/pages/goods/upShopHouseDetail?orderId=${row.orderId}`)
    },
    handleCurrentChange(val) {
      this._listInoutOrder(val)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 1px rgba(0, 0, 0, .1);
}

.margin-top-sm {
  margin-top: 20px;
}
</style>